import * as api from "..";

export function remove(commentId: number, id: number, params?: any) {
  return api.remove(`comments/${commentId}/attachments/${id}`, params);
}
